import {load} from '@shopify/theme-sections';

import '../sections/search-main';

const template = 'search';

export default (function () {
  if (document.body.dataset.template !== template) return;

  load('*');
})();
